import { z } from 'zod'
import { EvidenceId, IdempotencyKey, IsoTimestamp, Uuid } from '../primitives.js'
import { ActorKind, EvidenceObjectType } from '../enums.js'
import { JsonObject } from './common.js'

/** Input to `appendEvidence` (packages/evidence). */
export const EvidenceInput = z.object({
  objectType: EvidenceObjectType,
  schemaVersion: z.number().int().min(1),
  actorKind: ActorKind,
  actorId: z.string().min(1),
  agentId: Uuid.nullable().optional(),
  idempotencyKey: IdempotencyKey,
  sourceObjectIds: z.array(EvidenceId).optional(),
  payload: JsonObject,
})
export type EvidenceInput = z.input<typeof EvidenceInput>

/** A stored row of `evidence.objects`. */
export const EvidenceObject = z.object({
  id: EvidenceId,
  objectType: EvidenceObjectType,
  schemaVersion: z.number().int(),
  actorKind: ActorKind,
  actorId: z.string(),
  agentId: Uuid.nullable(),
  idempotencyKey: z.string(),
  sourceObjectIds: z.array(EvidenceId),
  payload: JsonObject,
  createdAt: IsoTimestamp,
})
export type EvidenceObject = z.output<typeof EvidenceObject>
